import React, { FC, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import CountryName from '@components/profile/profileOverlay/overlays/experience/experienceWrite/foreignExperienceForm/CountryName';
import ForeignDescription from '@components/profile/profileOverlay/overlays/experience/experienceWrite/foreignExperienceForm/ForeignDescription';
import ForeignPeriod from '@components/profile/profileOverlay/overlays/experience/experienceWrite/foreignExperienceForm/ForeignPeriod';

import styles from '../../experience.module.scss';
import { ExperienceFromVO } from '@domain/vo/profile/ProfileExperienceFormVO';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface IForeignExperienceItemProps {
  index: number;
  prefixName: string;
  defaultValues: Record<string, any>;
  onDeleteItem: () => void;
}

const ForeignExperienceItem: FC<IForeignExperienceItemProps> = ({ index, prefixName, defaultValues, onDeleteItem }) => {
  const { watch } = useFormContext();
  const isDisabledDeleteBtn = index == 0 && Object.values(watch(prefixName) ?? {}).filter((v) => !!v).length === 0;

  return (
    <div className={cx('activityInner')}>
      <button className={cx('btnDelete')} type="button" disabled={isDisabledDeleteBtn} onClick={onDeleteItem}>
        <Icon name="deleteLight" width={20} height={20} />
        삭제
      </button>

      <CountryName prefixName={prefixName} defaultValue={defaultValues.code} />
      <ForeignPeriod
        prefixName={prefixName}
        startDateDefaultValue={defaultValues.startDate}
        endDateDefaultValue={defaultValues.endDate}
      />
      <ForeignDescription prefixName={prefixName} defaultValue={defaultValues.description} />
    </div>
  );
};

interface IForeignExperienceFormProps {
  visible: boolean;
}
const ForeignExperienceForm: FC<IForeignExperienceFormProps> = ({ visible }) => {
  const { control } = useFormContext();

  const fieldName = 'foreignExperiences';
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const onAppendForeignExperience = () => {
    append(
      new ExperienceFromVO({
        tag: null,
        code: null,
        title: '',
        startDate: '',
        endDate: '',
        description: '',
      }),
    );
  };

  const foreignExperiencesEls = fields.map(({ id, ...field }, idx) => {
    const prefixName = `${fieldName}[${idx}]`;
    const onDeleteItem = () => {
      remove(idx);
    };

    return (
      <ForeignExperienceItem
        key={id}
        index={idx}
        prefixName={prefixName}
        defaultValues={field}
        onDeleteItem={onDeleteItem}
      />
    );
  });

  useEffect(() => {
    if (fields.length === 0) {
      onAppendForeignExperience();
    }
  }, [fields.length]);

  return (
    <div className={cx('activityArea', { hidden: !visible })}>
      <em className={cx('sectionTitle')}>해외 경험</em>
      {foreignExperiencesEls}

      <a className={cx('btnAdd')} role="button" onClick={onAppendForeignExperience}>
        <Icon name="addLight" width={24} height={24} />
        추가
      </a>
    </div>
  );
};

export default ForeignExperienceForm;
